// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function PorterStoreIcons$Close(Props) {
  var sizeOpt = Props.size;
  var colorOpt = Props.color;
  var strokeWidthOpt = Props.strokeWidth;
  var size = sizeOpt !== undefined ? sizeOpt : 24;
  var color = colorOpt !== undefined ? colorOpt : "#62728D";
  var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "1.5";
  var sizeStr = String(size);
  return React.createElement("svg", {
              height: sizeStr,
              width: sizeStr,
              fill: "none",
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: "M18 6L6 18M6 6L18 18",
                  stroke: color,
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: strokeWidth
                }));
}

var Close = {
  make: PorterStoreIcons$Close
};

function PorterStoreIcons$ChevronDown(Props) {
  var sizeOpt = Props.size;
  var colorOpt = Props.color;
  var strokeWidthOpt = Props.strokeWidth;
  var size = sizeOpt !== undefined ? sizeOpt : 20;
  var color = colorOpt !== undefined ? colorOpt : "#62728D";
  var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "1.5";
  var sizeStr = String(size);
  var halfSize = String(size / 2.0);
  var quarter = String(size * 0.325);
  var threeQuarter = String(size * 0.675);
  var sixtyPct = String(size * 0.6);
  return React.createElement("svg", {
              height: sizeStr,
              width: sizeStr,
              fill: "none",
              viewBox: "0 0 " + sizeStr + " " + sizeStr
            }, React.createElement("path", {
                  d: "M" + quarter + " " + quarter + "L" + halfSize + " " + sixtyPct + "L" + threeQuarter + " " + quarter,
                  stroke: color,
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: strokeWidth
                }));
}

var ChevronDown = {
  make: PorterStoreIcons$ChevronDown
};

function PorterStoreIcons$StatusChevron(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("path", {
                  d: "M6.5 8.5L10 12L13.5 8.5",
                  stroke: "#62728D",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var StatusChevron = {
  make: PorterStoreIcons$StatusChevron
};

function PorterStoreIcons$SizeChevron(Props) {
  return React.createElement("svg", {
              height: "16",
              width: "16",
              fill: "none",
              viewBox: "0 0 16 16"
            }, React.createElement("path", {
                  d: "M4 5.65L8 9.65L12 5.65",
                  stroke: "#0A57FF",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var SizeChevron = {
  make: PorterStoreIcons$SizeChevron
};

function PorterStoreIcons$StatusCheck(Props) {
  return React.createElement("svg", {
              className: "ps-status-dropdown__check",
              height: "16",
              width: "16",
              fill: "none",
              viewBox: "0 0 16 16"
            }, React.createElement("rect", {
                  height: "16",
                  width: "16",
                  fill: "#0A57FF",
                  rx: "4"
                }), React.createElement("path", {
                  d: "M4.5 8L7 10.5L11.5 5.5",
                  stroke: "#FCFDFD",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var StatusCheck = {
  make: PorterStoreIcons$StatusCheck
};

function PorterStoreIcons$SizeCheck(Props) {
  return React.createElement("svg", {
              height: "12",
              width: "12",
              fill: "none",
              viewBox: "0 0 12 12"
            }, React.createElement("path", {
                  d: "M2.5 6L5 8.5L9.5 3.5",
                  stroke: "#0A57FF",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var SizeCheck = {
  make: PorterStoreIcons$SizeCheck
};

function PorterStoreIcons$FilterCheck(Props) {
  return React.createElement("svg", {
              height: "8",
              width: "10",
              fill: "none",
              viewBox: "0 0 10 8"
            }, React.createElement("path", {
                  d: "M1 4L3.5 6.5L9 1",
                  stroke: "white",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var FilterCheck = {
  make: PorterStoreIcons$FilterCheck
};

function PorterStoreIcons$ToastSuccess(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("circle", {
                  cx: "10",
                  cy: "10",
                  fill: "#22C36D",
                  r: "10"
                }), React.createElement("path", {
                  d: "M6 10L9 13L14 7",
                  stroke: "#FCFDFD",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var ToastSuccess = {
  make: PorterStoreIcons$ToastSuccess
};

function PorterStoreIcons$ToastError(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("circle", {
                  cx: "10",
                  cy: "10",
                  fill: "#F43F5E",
                  r: "10"
                }), React.createElement("path", {
                  d: "M10 6V11",
                  stroke: "#FCFDFD",
                  strokeLinecap: "round",
                  strokeWidth: "1.5"
                }), React.createElement("circle", {
                  cx: "10",
                  cy: "14",
                  fill: "#FCFDFD",
                  r: "1"
                }));
}

var ToastError = {
  make: PorterStoreIcons$ToastError
};

function PorterStoreIcons$AddAction(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("circle", {
                  cx: "10",
                  cy: "10",
                  fill: "#0A57FF",
                  r: "9"
                }), React.createElement("path", {
                  d: "M10 6V14M6 10H14",
                  stroke: "#FCFDFD",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var AddAction = {
  make: PorterStoreIcons$AddAction
};

function PorterStoreIcons$RemoveAction(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("circle", {
                  cx: "10",
                  cy: "10",
                  fill: "#283548",
                  r: "9",
                  stroke: "#283548",
                  strokeWidth: "1"
                }), React.createElement("path", {
                  d: "M13 7L7 13M7 7L13 13",
                  stroke: "#FFFFFF",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var RemoveAction = {
  make: PorterStoreIcons$RemoveAction
};

function PorterStoreIcons$ImagePlaceholder(Props) {
  return React.createElement("svg", {
              height: "32",
              width: "32",
              fill: "none",
              viewBox: "0 0 32 32"
            }, React.createElement("path", {
                  d: "M8 6H24C25.1046 6 26 6.89543 26 8V24C26 25.1046 25.1046 26 24 26H8C6.89543 26 6 25.1046 6 24V8C6 6.89543 6.89543 6 8 6Z",
                  stroke: "#CBD5E1",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }), React.createElement("path", {
                  d: "M6 21L11 16L16 21",
                  stroke: "#CBD5E1",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }), React.createElement("path", {
                  d: "M18 19L21 16L26 21",
                  stroke: "#CBD5E1",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }), React.createElement("circle", {
                  cx: "20.5",
                  cy: "11.5",
                  r: "2",
                  stroke: "#CBD5E1",
                  strokeWidth: "1.5"
                }));
}

var ImagePlaceholder = {
  make: PorterStoreIcons$ImagePlaceholder
};

function PorterStoreIcons$Search(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("circle", {
                  cx: "9",
                  cy: "9",
                  r: "6",
                  stroke: "#62728D",
                  strokeWidth: "1.5"
                }), React.createElement("path", {
                  d: "M13.5 13.5L17 17",
                  stroke: "#62728D",
                  strokeLinecap: "round",
                  strokeWidth: "1.5"
                }));
}

var Search = {
  make: PorterStoreIcons$Search
};

function PorterStoreIcons$SearchClear(Props) {
  return React.createElement("svg", {
              height: "16",
              width: "16",
              fill: "none",
              viewBox: "0 0 16 16"
            }, React.createElement("path", {
                  d: "M12 4L4 12M4 4L12 12",
                  stroke: "#62728D",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var SearchClear = {
  make: PorterStoreIcons$SearchClear
};

function PorterStoreIcons$Filter(Props) {
  return React.createElement("svg", {
              height: "16",
              width: "16",
              fill: "none",
              viewBox: "0 0 24 24"
            }, React.createElement("path", {
                  d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z",
                  fill: "#62728D"
                }));
}

var Filter = {
  make: PorterStoreIcons$Filter
};

function PorterStoreIcons$Home(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("path", {
                  d: "M3 10L10 3L17 10",
                  stroke: "#283548",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }), React.createElement("path", {
                  d: "M5 8.5V16C5 16.5523 5.44772 17 6 17H14C14.5523 17 15 16.5523 15 16V8.5",
                  stroke: "#283548",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var Home = {
  make: PorterStoreIcons$Home
};

function PorterStoreIcons$Download(Props) {
  return React.createElement("svg", {
              height: "20",
              width: "20",
              fill: "none",
              viewBox: "0 0 20 20"
            }, React.createElement("path", {
                  d: "M10 3V13M10 13L6 9M10 13L14 9",
                  stroke: "#283548",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }), React.createElement("path", {
                  d: "M3 15V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V15",
                  stroke: "#283548",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5"
                }));
}

var Download = {
  make: PorterStoreIcons$Download
};

function PorterStoreIcons$EmptyDocument(Props) {
  return React.createElement("svg", {
              height: "48",
              width: "48",
              fill: "none",
              viewBox: "0 0 48 48"
            }, React.createElement("path", {
                  d: "M16 12H32C33.1046 12 34 12.8954 34 14V34C34 35.1046 33.1046 36 32 36H16C14.8954 36 14 35.1046 14 34V14C14 12.8954 14.8954 12 16 12Z",
                  stroke: "#CBD5E1",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "2"
                }), React.createElement("path", {
                  d: "M20 20H28M20 26H26",
                  stroke: "#CBD5E1",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "2"
                }));
}

var EmptyDocument = {
  make: PorterStoreIcons$EmptyDocument
};

export {
  Close ,
  ChevronDown ,
  StatusChevron ,
  SizeChevron ,
  StatusCheck ,
  SizeCheck ,
  FilterCheck ,
  ToastSuccess ,
  ToastError ,
  AddAction ,
  RemoveAction ,
  ImagePlaceholder ,
  Search ,
  SearchClear ,
  Filter ,
  Home ,
  Download ,
  EmptyDocument ,
  
}
/* react Not a pure module */
